module.exports = __webpack_public_path__ + "static/img/2.367bb9cb.png";